import { Injectable } from "@angular/core";
import { Timeframe } from "../models/timeframe";
import * as firebase from "firebase";
import * as moment from "moment";

@Injectable({
  providedIn: "root"
})
export class DateService {
  get timestamp() {
    return firebase.firestore.Timestamp.fromDate;
  }

  get today(): Timeframe {
    const begin = moment()
      .startOf("day")
      .add(2, "hours")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get yesterday(): Timeframe {
    const begin = moment()
      .startOf("day")
      .subtract(1, "day")
      .add(2, "hours")
      .toDate();
    const end = moment()
      .startOf("day")
      .add(2, "hours")
      .toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get weekToDate(): Timeframe {
    const begin = moment()
      .startOf("week")
      .add(2, "hours")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get last7Days(): Timeframe {
    const begin = moment()
      .subtract(7, "days")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get lastWeek(): Timeframe {
    const begin = moment()
      .startOf("week")
      .subtract(7, "days")
      .add(2, "hours")
      .toDate();
    const end = moment()
      .startOf("week")
      .add(2, "hours")
      .toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get last30Days(): Timeframe {
    const begin = moment()
      .subtract("30", "days")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get lastMonth(): Timeframe {
    const begin = moment()
      .startOf("month")
      .subtract("1", "month")
      .add(2, "hours")
      .toDate();
    const end = moment()
      .startOf("month")
      .add(2, "hours")
      .toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }
  get monthToDate(): Timeframe {
    const begin = moment()
      .startOf("month")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  get yearToDate(): Timeframe {
    const begin = moment()
      .startOf("year")
      .add(2, "hours")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }
  get last12Months(): Timeframe {
    const begin = moment()
      .subtract(12, "months")
      .toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }
  get lastCalendarYear(): Timeframe {
    const begin = moment()
      .startOf("year")
      .subtract(1, "year")
      .add(2, "hours")
      .toDate();
    const end = moment()
      .startOf("year")
      .add(2, "hours")
      .toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }
  get allTime(): Timeframe {
    const begin = moment("20190504", "YYYYMMDD").toDate();
    const end = moment().toDate();
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  custom(begin: Date, end: Date): Timeframe {
    return new Timeframe(this.timestamp(begin), this.timestamp(end));
  }

  getUniqueDates(dates: moment.Moment[]): Date[] {
    const result = dates.reduce(
      (a, c) => ((a[c.format("MM/DD/YYYY")] = c), a),
      {}
    );
    return (Object.values(result) as moment.Moment[]).map(mom => mom.toDate());
  }
  isSameDate(a: Date, b: Date) {
    return moment(a).format("MM/DD/YY") == moment(b).format("MM/DD/YY");
  }

  getString(d: Date) {
    return moment(d).format("MM/DD/YY");
  }

  getBlackoutString(from: Date, to?: Date) {
    if (to == null) {
      return moment(from).format("MM/DD/YY");
    } else {
      return (
        moment(from).format("MM/DD/YY") + " - " + moment(to).format("MM/DD/YY")
      );
    }
  }
}
